<template>
  <div>
    <transactions
      :transaction-class="transactionClass"
      verbose-name="Remboursement"
      verbose-name-plural="Remboursements"
      ressource="refunds"
      :add="false"
      :colors="colors"
      :display-pay="true"
    ></transactions>
  </div>
</template>

<script>
import { Hk } from '@/node-sdk'

import Transactions from '@/router/view/commercial/components/transactions'

const { Refund } = Hk.Crm
export default {
  name: 'refunds',

  components: {
    Transactions,
  },

  data() {
    return {
      transactionClass: null,
      colors: {
        pending: 'warning',
        accepted: 'success',
        canceled: 'danger',
      },
    }
  },

  mounted() {
    this.transactionClass = Refund
  },
}
</script>

<style></style>
